import { islamicGreen, redColor } from "../../../../../common/helpers/colors";

export const tsLNA = 6; // Transcript was not analyzed

export const calculateColor = (item) => {
  let color = "#000000";
  if (item.ensembl_support_level) {
    color = item.ensembl_support_level === "1" ? islamicGreen : redColor;
  }
  const tslStyle = {
    color:
      parseInt(item.ensembl_support_level, 10) === tsLNA ? "#000000" : color,
    fontWeight:
      parseInt(item.ensembl_support_level, 10) === tsLNA ? "normal" : "bold",
  };
  return tslStyle;
};

export const calculateTSL = (item) => {
  let TSL = "-";
  if (item.ensembl_support_level) {
    TSL =
      parseInt(item.ensembl_support_level, 10) === tsLNA
        ? "NA"
        : item.ensembl_support_level;
  }
  return TSL;
};
